import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import auditLogReducer from '../store/AuditLogSlices/auditLogSlice';
import blackBaudLogReducer from '../store/BlackBaudSlices/blackBaudSlice';
import blackBaudTransactionLogReducer from '../store/BlackBaudSlices/blackBaudTransactionLogSlice';
import themesReducer from '../store/features/auth/themesSlice';
import themeReducer from '../store/features/themeSlice';
import timezoneReducer from '../store/features/timezoneSlice';
import actualsListingReducer from '../store/Financials/actualsListingSlice';
import budgetListingReducer from '../store/Financials/budgetListingSlice';
import importDataReducer from '../store/Financials/importDataSlice';
import subChartReducer from '../store/Financials/saveChartSlice';
import subChartAccountsTableReducer from '../store/Financials/subChartsAccountTableSlice';
import projectInvoiceApproverReducer from '../store/FiscalSettings/ProjectInvoiceApproverSlice';
import createGLAdjustmentReducer from "../store/GLAdjustments/createNewGlAdjustmentSlice";
import invoiceCountReducer from '../store/Invoice/invoiceCountSlice';
import vendorInvoiceReducer from '../store/Invoice/vendorInvoiceSlice';
import vendorInvoiceTaskReducer from '../store/Invoice/vendorInvoiceTaskSlice';
import menuItemsReducer from '../store/MenutItems/menuItemsSlice';
import menuUiReducer from '../store/MenutItems/menuUiSlice';
import netSuiteLogReducer from '../store/NetSuiteSlices/netSuiteLogSlice';
import quickBooksLogReducer from '../store/QuickBooksSlices/quickBooksLogSlice';
import specialPaymentHistoryReducer from '../store/SpecialPayments/specialPaymentsHistory';
import specialPaymentReducer from '../store/SpecialPayments/specialPaymentSlice';
import tableReducer from '../store/tableSlice';
import alertReducer from './features/auth/alertSlice';
import allRolesReducer from './features/auth/allRoleDetailsSlice';
import authReducer from './features/auth/authSlice';
import createParticipantReducer from './features/auth/createParticpantSlice';
import participantsReducer from './features/auth/fundParticipantsSlice';
import newFundReducer from './features/auth/newFundSlice';
import participantAdminProfileReducer from './features/auth/participantAdminProfileSlice';
import profileSettingsReducer from './features/auth/profileSettingsSlice';
import searchRetainReducer from './features/auth/searchRetainSlice';
import transferFundReducer from './features/auth/transferFundsSlice';
import rolesReducer from './features/auth/userRoleSlice';
import makePaymentReducer from "./LoansStore/makePaymentSlice";
import createNewLoanReducer from "./LoansStore/newLoanSlice";
import newInvoiceReducer from './ProjectInvoices/newProjectInvoiceSlice';
import specialFundReducer from './SpecialFunds/createNewFundSlice';

// makePaymentReducer
// General persist configuration for reducers
const createPersistConfig = (key: string) => ({
  key,
  storage,
});

// Combine reducers and apply persistence
const appReducer = combineReducers({
  table: persistReducer(createPersistConfig('table'), tableReducer),
  auth: persistReducer(createPersistConfig('auth'), authReducer),
  roles: persistReducer(createPersistConfig('roles'), rolesReducer),
  allRole: persistReducer(createPersistConfig('allRole'), allRolesReducer),
  participantDetails: persistReducer(createPersistConfig('participants'), participantsReducer),
  createParticipant: persistReducer(createPersistConfig('createParticipant'), createParticipantReducer),
  newFund: persistReducer(createPersistConfig('newFundCreation'), newFundReducer),
  searchFileds: persistReducer(createPersistConfig('searchRetain'), searchRetainReducer),
  tranferFund: persistReducer(createPersistConfig('TransferFunds'), transferFundReducer),
  profileSettings: persistReducer(createPersistConfig('profileSettings'), profileSettingsReducer),
  alert: alertReducer,
  auditLog: persistReducer(createPersistConfig('auditLog'), auditLogReducer),
  createNewLoan: persistReducer(createPersistConfig('createNewLoan'), createNewLoanReducer),
  participantAdminProfile: persistReducer(createPersistConfig('participantAdminProfile'), participantAdminProfileReducer),
  netSuiteLog: persistReducer(createPersistConfig('netSuiteLog'), netSuiteLogReducer),
  quickBooksLog: persistReducer(createPersistConfig('quickBooksLog'), quickBooksLogReducer),
  blackBaudLog: persistReducer(createPersistConfig('blackBaudLog'), blackBaudLogReducer),
  blackBaudTransactionLog: persistReducer(createPersistConfig('blackBaudTransactionLog'), blackBaudTransactionLogReducer),
  projectInvoiceApprover: persistReducer(createPersistConfig('projectInvoiceApprover'), projectInvoiceApproverReducer),
  specialPayment: persistReducer(createPersistConfig('specialPayment'), specialPaymentReducer),
  specialFund: persistReducer(createPersistConfig('specialFund'), specialFundReducer),
  newInvoice: persistReducer(createPersistConfig('newInvoice'), newInvoiceReducer),
  budgetListing: persistReducer(createPersistConfig('budgetListing'), budgetListingReducer),
  actualsListing: persistReducer(createPersistConfig('actualsListing'), actualsListingReducer),
  subChartAccountsTable: persistReducer(createPersistConfig('actualsListing'), subChartAccountsTableReducer),
  themes: persistReducer(createPersistConfig('themes'), themesReducer),
  timezone: persistReducer(createPersistConfig('timezone'), timezoneReducer),
  importData: persistReducer(createPersistConfig('importData'), importDataReducer),
  specialPaymentHistory: persistReducer(createPersistConfig('specialPaymentHistory'), specialPaymentHistoryReducer),

  makePayments: persistReducer(createPersistConfig('makePayment'), makePaymentReducer),
  createGLAdjustment: persistReducer(createPersistConfig('createGLAdjustment'), createGLAdjustmentReducer),
  vendorInvoicelist: persistReducer(createPersistConfig('vendorInvoice'), vendorInvoiceReducer),
  vendorInvoiceTasklist: persistReducer(createPersistConfig('vendorInvoiceTask'), vendorInvoiceTaskReducer),
  invoiceCount: persistReducer(createPersistConfig('invoiceCount'), invoiceCountReducer),
  subChart: persistReducer(createPersistConfig('subChart'), subChartReducer),
  menuItems: persistReducer(createPersistConfig('menuUi'), menuItemsReducer),
  theme: themeReducer,
  menuUi: menuUiReducer,

});


const rootReducer = (state: any, action: any) => {
  if (action.type === 'RESET') {
    state = {
      table: state.table,
      participantAdminProfile: state.participantAdminProfile, 
      createNewLoan: state.createNewLoan,
      auditLog: state.auditLog,   
      quickBooksLog: state.quickBooksLog,
      netSuiteLog: state.netSuiteLog,
      blackBaudLog: state.blackBaudLog,
    };
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializability check
    }),
});

// Create a persistor instance
export const persistor = persistStore(store);

// TypeScript helpers for state and dispatch
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

